module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-01.99b70ed1.jpg";